module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-field"
  }, [_c('label', {
    class: {
      active: !!_vm.value
    },
    attrs: {
      "for": _vm.name
    }
  }, [_vm._v(_vm._s(_vm.label))]), _vm._v(" "), _c('input', {
    class: {
      'invalid': !!_vm.errors
    },
    attrs: {
      "name": _vm.name,
      "id": _vm.name,
      "type": _vm.type,
      "required": _vm.required,
      "pattern": _vm.pattern
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "input": _vm.change
    }
  }), _vm._v(" "), _c('error-message', {
    attrs: {
      "errors": _vm.errors
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-06878f82","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/inputs/text.vue
// module id = 358
// module chunks = 0